import { useQuery } from '@apollo/client';
import {
  LoadingPage,
  LoadingPageProps,
  PageLayout,
  PageLayoutProps,
} from '@kizi/comparator-components';
import {
  ComparatorContext,
  healthOrderStatusQueryApollo,
  useField,
} from '@kizi/comparator-core';
import React, { useContext } from 'react';

export interface CheckoutPageProps extends PageLayoutProps {
  loadingPage: LoadingPageProps;
  errorPage: PageLayoutProps;
}

export const CheckoutPage: React.FC<CheckoutPageProps> = ({
  loadingPage,
  errorPage,
  ...pageLayoutProps
}) => {
  const orderIdField = useField('orderId');

  if (orderIdField?.value === 'error') {
    return (
      <PageLayout
        contentStyles={{
          mx: 'auto',
          span: [12, 12, 12, 12],
          width: [null, null, null, 810],
        }}
        {...errorPage}
      />
    );
  }

  const { api } = useContext(ComparatorContext);

  const {
    loading: statusOrderLoading,
    error: statusOrderError,
    data: statusOrderData,
    stopPolling,
  } = useQuery(healthOrderStatusQueryApollo, {
    variables: { orderId: orderIdField?.value },
    pollInterval: 2000,
    context: {
      uri: `${process.env.KIZI_PUBLIC_DOMAIN}/order/graphql`,
      headers: {
        'Authorization': 'Bearer ' + api.credentials.token,
      },
    },
  });

  if (
    statusOrderLoading ||
    statusOrderData?.orderStatus?.status === 'QUEUED' ||
    statusOrderData?.orderStatus?.status === 'PROCESSING'
  )
    return <LoadingPage {...loadingPage} />;

  if (statusOrderError || statusOrderData?.orderStatus?.status === 'ERROR') {
    stopPolling();
    return (
      <PageLayout
        contentStyles={{
          mx: 'auto',
          span: [12, 12, 12, 12],
          width: [null, null, null, 810],
        }}
        {...errorPage}
      />
    );
  }

  if (
    statusOrderData?.orderStatus?.status === 'DONE' ||
    statusOrderData?.orderStatus?.status === 'UNDER_REVIEW' ||
    statusOrderData?.orderStatus?.status === 'QUEUED_FOR_SAVING'
  ) {
    localStorage.removeItem(`kizi-comparator-triple-play`);
    localStorage.removeItem('apollo-cache-persist');
    localStorage.removeItem('lastProductId');
    stopPolling();
  }

  return (
    <PageLayout
      contentStyles={{
        mx: 'auto',
        span: [12, 12, 12, 12],
        width: [null, null, null, 810],
      }}
      {...pageLayoutProps}
    />
  );
};
